// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Yh","icon":"e_Zh","pathBg":"e__h","pathFg":"e_0h","variantViolet":"e_1h","variantBase":"e_2h"};